interface Props {
  fill?: string;
}

const Warmup = ({ fill = '#000' }: Props) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={fill} fillRule="evenodd">
      <path d="M9.435 16a.332.332 0 0 1-.116-.02c-.113-.04-2.77-1.025-5.07-3.247a.348.348 0 0 1-.01-.489.339.339 0 0 1 .484-.01c1.932 1.867 4.183 2.838 4.712 3.05.966-.383 7.657-3.267 7.867-9.467l.014-.311c-.04-2.6-1.984-4.815-4.243-4.815-1.258 0-2.458.692-3.294 1.9a.34.34 0 0 1-.56 0c-.836-1.208-2.036-1.9-3.293-1.9-2.259 0-4.201 2.179-4.242 4.758l.01.359a.345.345 0 0 1-.331.356c-.163.01-.346-.145-.352-.336L1 5.454C1.048 2.44 3.258 0 5.926 0c1.346 0 2.627.658 3.573 1.822C10.446.658 11.726 0 13.073 0c2.624 0 4.88 2.527 4.927 5.517l-.015.329c-.24 7.117-8.354 10.105-8.436 10.134a.34.34 0 0 1-.114.02" />
      <path d="M9.808 12a.338.338 0 0 1-.314-.218l-2.533-6.44-1.355 4.025a.34.34 0 0 1-.32.235H.34A.343.343 0 0 1 0 9.252c0-.192.151-.348.34-.348h4.705l1.57-4.67A.34.34 0 0 1 6.929 4a.34.34 0 0 1 .323.218l2.536 6.447 1.682-4.904a.341.341 0 0 1 .302-.233.342.342 0 0 1 .324.197l.733 1.57h1.833c.188 0 .339.155.339.348a.344.344 0 0 1-.34.35h-2.045a.34.34 0 0 1-.306-.198l-.472-1.01-1.709 4.983a.342.342 0 0 1-.312.232h-.008z" />
    </g>
  </svg>
);

export default Warmup;
